
export const getActualSalesPosting = state => {
  return state.actualSalesPosting
}

export const getActualSalesErrors = state => {
  return state.actualSalesErrors
}

export const getActualSalesTotals = state => {
  return state.actualSalesTotals
}

export const getActualSalesPosted = state => {
  return state.actualSalesPosted
}


export const getMainListQuickFilter = state => {
  return state.mainListQuickFilters
}

export const getQuickFiltersDatesFrom = state => {
  return state.quickFiltersDatesFrom
}

export const getQuickFiltersDatesTo = state => {
  return state.quickFiltersDatesTo
}